// extracted by mini-css-extract-plugin
export var noSpinners = "_p2-6";
export var percentageInput = "_p2-7";
export var variantColor1 = "_p2-0";
export var variantColor2 = "_p2-1";
export var variantColor3 = "_p2-2";
export var variantColor4 = "_p2-3";
export var variantColor5 = "_p2-4";
export var variantColor6 = "_p2-5";